import React, { Component } from 'react';
import { SpinLoader } from 'app/components';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { CodeCategory } from 'app/area/codetable/list/search/code-category';
import { CodetableListItems } from 'app/area/codetable/list/list-items';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';
import { CodetableListComponentProps } from './types';
import { ResizeWrapper } from 'app/components/resize-wrapper';
import styles from './default-codetable-list-content.scss';

interface DefaultCodetableListContentProps extends CodetableListComponentProps {
  children?: React.ReactNode;
}

export class DefaultCodetableListContent extends Component<DefaultCodetableListContentProps> {
  public render() {
    const { category, metadata, codetableOptions, isHierarchy, isHierarchyMode, shouldRenderList,
      shouldRenderSpinLoader, hasCategoryMetadata, hasSelectedCategory, breadcrumbs, codetableId,
      codeId, codeListBranchState, codeListBranch, rootBranch, codeAccessConfiguration, itemAccess,
      fetchingItemAccess, fetchingCodeParent, mergeCode, translation, children, validation, updateCategory, loadCodetableOptions,
      loadFromParent, expandCodeItem, deleteCodeItem, listCategoryLabel, loadCodesAccess, clearCodesAccess, reloadCodeItems,
      updateMergeCode, updateCodeParent, updateConfirmPrompt, updateValidation, resetValidation
    } = this.props;

    return <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
      <div className={styles.codetableListHolder}>
        <CodeCategory
          breadcrumbs={breadcrumbs}
          category={category}
          metadata={metadata}
          options={codetableOptions}
          loadOptions={loadCodetableOptions}
          onChange={updateCategory}
          translation={translation}
          listCategoryLabel={listCategoryLabel}
        />
        <div className={styles.numberOfResults}>
          {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
            && <NumberOfResults
              rootBranch={rootBranch}
              translation={translation} />}
        </div>

        {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
        {
          shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>
            {children}
            <div className={styles.listItems}>
              <ResizeWrapper>
                <CodetableListItems
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  fetchingCodeParent={fetchingCodeParent}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codetableName={metadata?.label}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  reloadCodeItems={reloadCodeItems}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory}
                  metadata={metadata}
                  validation={validation}
                  updateValidation={updateValidation}
                  resetValidation={resetValidation}
                  mergeCode={mergeCode}
                  updateMergeCode={updateMergeCode}
                  updateCodeParent={isHierarchy && updateCodeParent}
                  updateConfirmPrompt={updateConfirmPrompt}
                  options={codetableOptions}
                  loadOptions={loadCodetableOptions} />
              </ResizeWrapper>
            </div>
          </div>
        }
        {hasCategoryMetadata && !hasSelectedCategory && <p className="no-content">{translation.no_category}</p>}
      </div>
    </div>;
  }
}
